import type { AktionEntwurf, AktionKontext, AktionModul, AktionsTyp } from './types';

// Factory: eigene, isolierte Registry — für Tests ohne globalen State.
export function createAktionsRegistry() {
  const module = new Map<AktionsTyp, AktionModul>();
  return {
    registriere(modul: AktionModul): void {
      module.set(modul.typ, modul);
    },
    lade(typ: AktionsTyp): AktionModul | undefined {
      return module.get(typ);
    },
    alle(): AktionModul[] {
      return [...module.values()];
    },
    // Alle Module durchlaufen und die nicht-null Entwürfe sammeln.
    erzeugeEntwuerfe(ctx: AktionKontext): AktionEntwurf[] {
      return [...module.values()]
        .map((m) => m.erzeugen(ctx))
        .filter((e): e is AktionEntwurf => e !== null);
    },
  };
}

// Default-Singleton — reale Aktionstypen werden in Etappe 4 hier registriert.
export const aktionsRegistry = createAktionsRegistry();
